import { render, staticRenderFns } from "./AccountCredits.vue?vue&type=template&id=1201ae36&scoped=true&"
import script from "./AccountCredits.vue?vue&type=script&lang=js&"
export * from "./AccountCredits.vue?vue&type=script&lang=js&"
import style0 from "./AccountCredits.vue?vue&type=style&index=0&id=1201ae36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1201ae36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VProgressCircular,VRow})
